import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { BaseAPIService } from '../Services/api.base.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from "@angular/router";
import { IAlarmsDetail } from '../Models/IAlarmsDetails';
import { label } from '../constants/labels';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { rolesdef } from '../constants/role-def';
import { INotifyName } from '../Models/INotifyTo';
import { IGridCols } from '../Models/IGridCols';
import { IRule } from '../Models/IRule';
import { IDescValue } from '../Models/IDescValue';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-alarms',
  standalone: false,
  templateUrl: './alarms.component.html',
  styleUrls: ['./alarms.component.scss'],
  providers: [MessageService]
})
export class AlarmsComponent implements OnInit {
  @ViewChild(('filtr')) filtr: ElementRef;
  @ViewChild(('dt')) dt: Table;
  showRuleDetails: boolean = false;
  isLoading: boolean;
  alarmInfo: IAlarmsDetail[];
  cols: Array<IGridCols>;
  closeResult: string;
  labels: any;
  noData: boolean = false;
  isPagination = true;
  targetSearch: string;
  event: Event;
  modalReference: NgbModalRef;
  contentHeader: string;
  applyToNotifyName: Array<INotifyName>;
  CanOnlySelectThemself: boolean = false;
  alarmRuleName: string;
  maxVal: number;
  minVal: number;
  notifiedTo: string;
  severity: number;
  delay: number;
  selectedRes: string;
  ruleData: IRule;
  ruleId: Array<any> = [];
  applyToNotifyToData: Array<INotifyName> = [];
  roles: any;
  roleCd: string;
  showAlarmWhen: boolean = false;
  selectedalarmWhen: number;
  alarmWhenList: Array<IDescValue>;
  selectedDongleUId: string = '';
  isMobile: boolean = false;
  constructor(private readonly baseService: BaseAPIService, private readonly auth: AuthenticationService,
    private readonly route: ActivatedRoute, private readonly translate: TranslateService) { }

  ngOnInit() {
    if (window.innerWidth >= 1200) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
    this.labels = label;
    this.isLoading = true;
    this.targetSearch = this.route.snapshot.paramMap.get("coolerName");
    this.cols = [
      { field: 'dongleUId', header: this.labels.tableHeaderUid, width: '4em', dataType: 'string' },
      { field: 'deviceName', header: this.labels.tableHeaderDevice, width: '7em', dataType: 'string' },
      { field: 'locationCountry', header: this.labels.tableHeaderGeoLocation, width: '4.5em', dataType: 'string' },
      { field: 'startedOn', header: this.labels.tableHeaderStart, width: '5em', dataType: 'date' },
      { field: 'endedOn', header: this.labels.tableHeaderEnd, width: '5em', dataType: 'date' },
      { field: 'isActive', header: this.labels.tableHeaderStatus, width: '3em', dataType: 'string' },
      { field: 'severity', header: this.labels.tableHeaderAlarmType, width: '4.5em', dataType: 'string' },
      { field: 'ruleIdName', header: this.labels.tableHeaderRule, width: '3.5em', dataType: 'string' },
      { field: 'resourceName', header: this.labels.tableHeaderResource, width: '4em', dataType: 'string' }
    ];
    this.alarmWhenList = [
      { desc: '0', value: 0 },
      { desc: '1', value: 1 },
    ]
    this.noData = false;
    this.GetAlarms();
    this.roles = rolesdef;
    this.roleCd = this.auth.authenticatedRoleCd;
    if (this.targetSearch !== null) {
      setTimeout(() => {
        this.filtr.nativeElement.dispatchEvent(new Event('input'));
      }, 0);
    }

  }

  GetAlarms() {
    this.baseService.GET('/alarm/alarms/').subscribe((result: IAlarmsDetail[]) => {
      if (result !== null && result.length > 0) {
        this.alarmInfo = result;
        this.isLoading = false;
        if (this.alarmInfo.length < 10) {
          this.isPagination = false;
        }
      }
      else {
        this.noData = true;
        this.isPagination = false;
        this.isLoading = false;
      }
    });
  }

  public getRuleDetails(data: any) {
    this.isLoading = true;
    this.ruleId = data.ruleIdName.split(' ');
    this.baseService.GET(`/Alarm/AlarmRuleByRuleId/${this.ruleId[1]}`).subscribe((result: Array<IRule>) => {
      this.ruleData = result[0];
      this.viewRule(data.dongleUId);
      this.isLoading = false;
    });
  }



  public viewRule(dongleUId) {
    this.contentHeader = this.ruleId.join(' ') + ' Details';
    this.showRuleDetails = true;
    this.isLoading = true;
    this.applyToNotifyName = [];
    this.alarmRuleName = this.ruleData.alarmName
    this.selectedDongleUId = dongleUId;
    if (this.ruleData.lowlimit === null) {
      this.showAlarmWhen = true;
      this.selectedalarmWhen = this.ruleData.highlimit;
    } else {
      this.showAlarmWhen = false;
      this.minVal = this.ruleData.lowlimit;
      this.maxVal = this.ruleData.highlimit;
    }
    this.notifiedTo = "";
    if (this.ruleData.notifiedTo.trim() !== "" && this.ruleData.notifiedToNameList.length > 0) {
      this.notifiedTo = this.ruleData.notifiedTo.concat(",").concat(...this.ruleData.notifiedToNameList.join(', '));
    }
    else if (this.ruleData.notifiedTo.trim() !== "" && this.ruleData.notifiedToNameList.length == 0) {
      this.notifiedTo = this.ruleData.notifiedTo;
    } else if (this.ruleData.notifiedTo.trim() == "") {
      this.notifiedTo = this.ruleData.notifiedToNameList.join(', ');
    }
    this.delay = this.ruleData.delayTimer;
    this.severity = this.ruleData.severity;
    this.selectedRes = this.ruleData.resourceName;
    this.showRuleDetails = true;
    this.isLoading = false;
  }

  public closeModal() {
    this.showRuleDetails = false;
  }
  public SearchFilter(stringVal: any) {
    if (this.dt) {
      this.dt.filterGlobal(stringVal, 'contains')
    }
  }
}
